<template>
  <v-container>
    <v-row>
      <v-col>
        <CustomerBase :customer="customer" :users="users" />
      </v-col>
    </v-row>
    <v-tabs v-if="customertabs" v-model="activeTab">
      <v-tab v-for="tab in customertabs" :key="tab.label" @click="visitTab(tab)">
        {{ tab.label }}
      </v-tab>
    </v-tabs>
    <v-row>
      <customer-branches
        :branches="branches"
        :company="customer"
      />
      <customer-contact-persons
        :branches="branches"
        :contact-persons="contactPersons"
        :company="customer"
      />
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import CustomerBranches from '@/Components/Customer/Branches'
import CustomerContactPersons from '@/Components/Customer/ContactPersons'
import CustomerBase from '@/Components/Customer/CustomerBase'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.customer.name ? this.customer.name : 'Loading...',
      }
   },
   components: {
      CustomerBranches,
      CustomerContactPersons,
      CustomerBase
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      customer: {
         type: Object,
         required: true,
      },
      branches: {
         type: Array,
         required: true,
      },
      contactPersons: {
         type: Array,
         required: true,
      },
      users: {
         type: Array,
         required: true,
      },
      customertabs: {
         type: Array,
         required: true,
      },
   },

   data () {
      return {
         dialog: false,
         companyForm: this.$inertia.form({
            customer_number: this.customer.customer_number,
            name: this.customer.name,
            name_short: this.customer.name_short,
            website: this.customer.website,
            created_by: this.customer.created_by,
         }),
         activeTab: 1,
      }
   },
   watch: {
      customertabs: function () {
         for (const key in this.customertabs) {
            if (!this.customertabs[key].route) {
               this.activeTab = parseInt(key)
               return
            }
         }
      },
   },
   methods: {
      save () {
         this.companyForm.patch(this.route('company.update', this.customer.id))
      },
      visitTab (tab) {
         if (tab.route) {
            this.$inertia.visit(tab.route)
         }
      },
   },
}
</script>
